// Collection Product Filters

let productCards = document.querySelectorAll('div.product-card');

// Collection Price Filters

function clearAll() {
	let 
		twohundred = document.querySelector('#twohundred'),
		zerotofifty = document.querySelector('#zero-to-fifty'),
		fiftytotwo = document.querySelector('#fifty-to-twohundred');

	if (twohundred.classList.contains('filter-selected') === false && zerotofifty.classList.contains('filter-selected') === false && fiftytotwo.classList.contains('filter-selected') === false ) {
		productCards.forEach(card => {
			card.classList.remove('hide-price')
		})
	}
};


function priceFilter(min, max) {

	productCards.forEach(card => {
		let priceSelector = card.querySelector('.product-price');
		let priceInner = priceSelector.innerHTML.replace('$', '');
		let parsedPrice = parseInt(priceInner);

		if (parsedPrice > min && parsedPrice < max) {
			card.classList.remove('hide-price');
			card.classList.toggle('chosen');
		}
	})
};

function addHide(event) {
	productCards.forEach(card => {
		if(card.classList.contains('chosen') === false) {
			card.classList.add('hide-price')
		}
	})
};

function clearAllPricesTag(event) {
	$('#all-prices').removeClass('filter-selected');
}

$(document).on('click', '#fifty-to-twohundred', function(event) {
	
	this.classList.toggle('filter-selected');

	priceFilter(51, 200);

	addHide();

	clearAll();

	clearAllPricesTag();

}),

$(document).on('click', '#zero-to-fifty', function(event) {
	
	this.classList.toggle('filter-selected');

	priceFilter(0, 50);

	addHide();

	clearAll();

	clearAllPricesTag();
}),

$(document).on('click', '#twohundred', function(event) {
	
	this.classList.toggle('filter-selected');

	priceFilter(201, 999999);

	addHide();

	clearAll();

	clearAllPricesTag();
}),

$(document).on('click', '#all-prices', function(event) {

	pricesContent = document.querySelectorAll('div.prices-content p');

	pricesContent.forEach(tag => {
		tag.classList.remove('filter-selected')
	});

	this.classList.add('filter-selected');

	productCards.forEach(card => {
		card.classList.remove('hide-price');
	});

});

// Collection Size Filters

sizesContent = document.querySelectorAll('div.sizes-content p');

$(document).on('click', '.size-filter', function(event) {

	sizesContent.forEach(tag => {
		if(tag == this) {
			tag.classList.add('filter-selected');
		} else {
			tag.classList.remove('filter-selected');
		}
	});

	let sizeClass = this.getAttribute('data-filter-size');

	productCards.forEach(card => {
		card.classList.remove('hide-size');

		let cardClass = card.className;

		if (cardClass.includes(sizeClass) == false) {
			card.classList.add('hide-size');
		}
	});

});

$(document).on('click', '#all-sizes', function(event) {

	sizesContent.forEach(tag => {
		if (tag == this) {
			tag.classList.add('filter-selected');
		} else {
			tag.classList.remove('filter-selected');
		}
	});

	productCards.forEach(card => {
		card.classList.remove('hide-size');
	})
});


// Collection Product Type Filters

typesContent = document.querySelectorAll('div.types-content p');

$(document).on('click', '.type-filter', function(event) {
	
	typesContent.forEach(tag => {
		if(tag == this) {
			tag.classList.add('filter-selected');
		} else {
			tag.classList.remove('filter-selected');
		}
	});

	let filterClass = this.getAttribute('data-filter-product-type');

	productCards.forEach(card => {
		card.classList.remove('hide-type');

		let cardClass = card.getAttribute('data-card-product-type');

		if (filterClass !== cardClass) {
			card.classList.add('hide-type');
		}
	})

});

$(document).on('click', '#all-types', function(event) {

	typesContent.forEach(tag => {
		if(tag == this) {
			tag.classList.add('filter-selected');
		} else {
			tag.classList.remove('filter-selected');
		}
	});

	productCards.forEach(card => {
		card.classList.remove('hide-type');
	})
});



// ==============================================
// Product Page Variant Selection
// ==============================================

(function() {
	'use strict';

	var SELECTORS = {
		optionRadio: '.js-product-option-radio',
		variantIdInput: '#js-product-variant-id',
		variantsJson: '#js-product-variants-json',
		addButton: '#add-to-cart-button',
		addForm: '#add-to-cart-form',
		optionLabel: '.product-option-label',
		optionGroup: '.product-option-group',
		cartCount: '.js-cart-item-count',
		price: '.js-product-price'
	};

	var CLASSES = {
		unavailable: 'is-unavailable',
		selected: 'is-selected',
		loading: 'is-loading',
		success: 'is-success',
		error: 'is-error'
	};

	function getVariantsData() {
		var $json = $(SELECTORS.variantsJson);
		if (!$json.length) return null;
		try {
			return JSON.parse($json.html());
		} catch (e) {
			return null;
		}
	}

	function getSelectedOptions() {
		var selected = [];
		$(SELECTORS.optionRadio + ':checked').each(function() {
			var index = parseInt($(this).data('option-index'), 10);
			selected[index] = $(this).val();
		});
		return selected;
	}

	function getOptionCount() {
		return $(SELECTORS.optionGroup).length;
	}

	function findMatchingVariant(variants, selectedOptions) {
		if (!variants) return null;

		for (var i = 0; i < variants.length; i++) {
			var variant = variants[i];
			var match = true;

			for (var j = 0; j < selectedOptions.length; j++) {
				if (selectedOptions[j] !== undefined && variant.options[j] !== selectedOptions[j]) {
					match = false;
					break;
				}
			}

			if (match) return variant;
		}
		return null;
	}

	// Check if an option value has any available variant
	function isOptionAvailable(variants, optionIndex, optionValue, selectedOptions) {
		return variants.some(function(variant) {
			// Must match this option value
			if (variant.options[optionIndex] !== optionValue) return false;
			// Must be available
			if (!variant.available) return false;
			// Must match all other selected options
			for (var i = 0; i < selectedOptions.length; i++) {
				if (i !== optionIndex && selectedOptions[i] !== undefined) {
					if (variant.options[i] !== selectedOptions[i]) return false;
				}
			}
			return true;
		});
	}

	function updateOptionAvailability(variants, selectedOptions) {
		$(SELECTORS.optionGroup).each(function() {
			var groupIndex = parseInt($(this).data('option-index'), 10);

			$(this).find(SELECTORS.optionRadio).each(function() {
				var $radio = $(this);
				var $label = $radio.next(SELECTORS.optionLabel);
				var optionValue = $radio.val();

				var hasAvailable = isOptionAvailable(variants, groupIndex, optionValue, selectedOptions);

				if (hasAvailable) {
					$label.removeClass(CLASSES.unavailable);
				} else {
					$label.addClass(CLASSES.unavailable);
				}
			});
		});
	}

	function navigateToVariantImage(variant) {
		if (!variant || !variant.featured_image_id) return;

		var $slideshow = $('.js-product-slideshow');
		if (!$slideshow.length) return;

		var $slides = $slideshow.find('.js-slides');
		if (!$slides.length || !$slides.hasClass('slick-initialized')) return;

		var $targetSlide = $slideshow.find('[data-image-id="' + variant.featured_image_id + '"]');
		if ($targetSlide.length) {
			var slideIndex = parseInt($targetSlide.data('slide-index'), 10);
			$slides.slick('slickGoTo', slideIndex);
		}
	}

	function updateProductState() {
		var $addButton = $(SELECTORS.addButton);
		var $variantIdInput = $(SELECTORS.variantIdInput);
		var optionCount = getOptionCount();
		var variants = getVariantsData();
		var selectedOptions = getSelectedOptions();

		// Update availability styling
		if (variants) {
			updateOptionAvailability(variants, selectedOptions);
		}

		// Count how many options are selected
		var selectedCount = selectedOptions.filter(function(opt) {
			return opt !== undefined;
		}).length;

		// Find the matching variant
		var matchedVariant = findMatchingVariant(variants, selectedOptions);

		// Navigate to variant image
		navigateToVariantImage(matchedVariant);

		// Update price display
		if (matchedVariant && matchedVariant.price) {
			$(SELECTORS.price).text(matchedVariant.price);
		}

		// Enable/disable add to cart button
		if (selectedCount === optionCount && matchedVariant && matchedVariant.available) {
			$addButton.prop('disabled', false);
			$variantIdInput.val(matchedVariant.id);
		} else {
			$addButton.prop('disabled', true);
			$variantIdInput.val('');
		}
	}

	function onProductOptionChange(event) {
		var $radio = $(event.target);
		var $label = $radio.next(SELECTORS.optionLabel);

		// Update selected state visually within this option group
		$radio.closest(SELECTORS.optionGroup).find(SELECTORS.optionLabel).removeClass(CLASSES.selected);
		$label.addClass(CLASSES.selected);

		// Update the product state (availability, button, price, image)
		updateProductState();
	}

	function setButtonState($button, state) {
		$button.removeClass(CLASSES.loading + ' ' + CLASSES.success + ' ' + CLASSES.error);
		if (state) {
			$button.addClass(state);
		}
	}

	function updateCartCount(count) {
		$(SELECTORS.cartCount).text('(' + count + ')');
	}

	function onFormSubmit(event) {
		event.preventDefault();

		var $form = $(event.target);
		var $button = $form.find(SELECTORS.addButton);
		var variantId = $(SELECTORS.variantIdInput).val();

		if (!variantId) return;

		setButtonState($button, CLASSES.loading);
		$button.prop('disabled', true);

		$.ajax({
			url: '/cart/add.js',
			type: 'POST',
			dataType: 'json',
			data: {
				id: variantId,
				quantity: 1
			},
			success: function(response) {
				setButtonState($button, CLASSES.success);

				$.getJSON('/cart.js', function(cart) {
					updateCartCount(cart.item_count);

					// Open cart drawer
					if (window.cartDrawer) {
						window.cartDrawer.open();
					}
				});

				setTimeout(function() {
					setButtonState($button, null);
					// Only re-enable if current variant selection is available
					var currentVariantId = $(SELECTORS.variantIdInput).val();
					if (currentVariantId) {
						$button.prop('disabled', false);
					}
				}, 1500);
			},
			error: function(xhr, status, error) {
				setButtonState($button, CLASSES.error);

				setTimeout(function() {
					setButtonState($button, null);
					// Only re-enable if current variant selection is available
					var currentVariantId = $(SELECTORS.variantIdInput).val();
					if (currentVariantId) {
						$button.prop('disabled', false);
					}
				}, 2000);
			}
		});
	}

	// Initialize product page options on load
	function initializeProductOptions() {
		var variants = getVariantsData();
		if (!variants) return;

		// Mark unavailable options on initial load (no options selected yet)
		$(SELECTORS.optionGroup).each(function() {
			var groupIndex = parseInt($(this).data('option-index'), 10);

			$(this).find(SELECTORS.optionRadio).each(function() {
				var $radio = $(this);
				var $label = $radio.next(SELECTORS.optionLabel);
				var optionValue = $radio.val();

				// Check if ANY variant with this option value is available
				var hasAvailable = variants.some(function(variant) {
					return variant.options[groupIndex] === optionValue && variant.available;
				});

				if (!hasAvailable) {
					$label.addClass(CLASSES.unavailable);
				}
			});
		});
	}

	function init() {
		// Initialize options first to show sold-out options
		initializeProductOptions();

		// Bind event handlers
		$(document).on('change', SELECTORS.optionRadio, onProductOptionChange);
		$(document).on('submit', SELECTORS.addForm, onFormSubmit);
	}

	$(document).ready(init);
})();


// Mobile Header Toggle

let toggleMenu = function(event) {
	var $headerBottom = $('.header-bottom');
	var $toggle = $('.mobile-menu-toggle');

	$headerBottom.toggleClass('is-open');

	if($headerBottom.hasClass('is-open')) {
		$('.js-menu-burger').hide();
		$('.js-menu-close').show();
		$toggle.attr('aria-expanded', 'true');
	} else {
		$('.js-menu-burger').show();
		$('.js-menu-close').hide();
		$toggle.attr('aria-expanded', 'false');
	}
};

$(document).on('click', '.js-mobile-menu', toggleMenu);


// Mobile Filter Menu Toggle

let toggleFilterMenu = function(event) {
	// $('.filter-title p').html('Filter -');

	$('.size-filters').toggleClass('closed');
	$('.type-filters').toggleClass('closed');

	if($('.size-filters').hasClass('closed')) {
		$('.filter-title').html('Filter +')
	} else {
		$('.filter-title').html('Filter -');
	}

	// if($('.price-filters').hasClass('closed')) {
	// 	$('.js-menu-burger').hide()
	// 	$('.js-menu-close').show()
	// } else {
	// 	$('.js-menu-burger').show()
	// 	$('.js-menu-close').hide()
	// }
};

$(document).on('click', '.filter-title', toggleFilterMenu);


// Product Slideshow

let
	slideSelector = '.js-slides',
	prevButtonSelector = '.js-slider-button-prev',
	nextButtonSelector = '.js-slider-button-next';
	pageSelector = '#page-product';

let
	productSlideshowSelector = '.js-product-slideshow',
	currentSlideSelector = '.js-current-slide',
	productSlideshows = {
		onBeforeChange: function(event, slick, currentSlide, nextSlide) {
			let $currentSlide = $('.js-current-slide');

			$currentSlide.text(nextSlide+1);
		},
		setup: function($element) {
			let
				$slides = $element.find(slideSelector),
				productSlideshowOptions = {
					fade: true,
					nextArrow: $('.js-slider-button-next'),
					prevArrow: $('.js-slider-button-prev')
				};

			if ($slides.children().length > 1) {
				$slides.on('beforeChange', productSlideshows.onBeforeChange).slick(productSlideshowOptions);
			}

		},
		init: function() {
			$(productSlideshowSelector).each(function() {
				productSlideshows.setup($(this));
			});
		}

	};

productSlideshows.init();


// Copy product URL to clipboard

let copyURL = function() {
		event.preventDefault();
		let copyText = document.getElementById('js-copy-url-text');
		copyText.select();
		copyText.setSelectionRange(0, 99999)
		document.execCommand('copy');

		$('#tooltip-text').css('opacity', '1');
}

let fadeOut = function () {
	$('#tooltip-text').css('opacity', '0');

	console.log('hello');
}

$('.js-copy-url').on('click', function() {
	copyURL();
	setTimeout(fadeOut, 1000);
})

// Cart Quantity Picker

let 
	quantityFieldSelector = '.js-quantity-field',
	quantityButtonSelector = '.js-quantity-button',
	quantityPickerSelector = '.js-quantity-picker',
	quantityPicker = {
			onButtonClick: function(event) {
				let 
					$button = $(this),
					$picker = $button.closest(quantityPickerSelector),
					$quantity = $picker.find('.js-quantity-field'),
					quantityValue = parseInt($quantity.val()),
					max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;

				if ($button.hasClass('plus') && (max === null || quantityValue + 1 <= max)) {
					$quantity.val(quantityValue + 1).change();

				} 
				else if ($button.hasClass('minus')) {
					$quantity.val(quantityValue - 1).change();
				}
			},
			onChange: function(event) {
				let
					$field = $(this),
					$picker = $field.closest(quantityPickerSelector),
					$quantityText = $picker.find('.js-quantity-text'),
					shouldDisableMinus = parseInt(this.value) === parseInt($field.attr('min')),
					$minusButton = $picker.find('.js-quantity-button.minus'),
					$plusButton = $picker.find('.js-quantity-button.plus'),
					shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max'));

				$quantityText.text(this.value);

				if (shouldDisableMinus) {
					$minusButton.prop('disabled', true)
				} else if ($minusButton.prop('disabled') === true) {
					$minusButton.prop('disabled', false)
				}

				if (shouldDisablePlus) {
					$plusButton.prop('disabled', true)
				} else if ($plusButton.prop('disabled') === true) {
					$plusButton.prop('disabled', false)
				}
			},
			onQtyChange: function(event) {

				$('.update-button').css('background-color', 'black');

			},
			init: function() {
				$(document).on('click', quantityButtonSelector, quantityPicker.onButtonClick);
				$(document).on('change', quantityFieldSelector, quantityPicker.onChange);
				$(document).on('change', quantityFieldSelector, quantityPicker.onQtyChange);
			}
		};

quantityPicker.init();


// ==============================================
// Quick Add-to-Cart (Product Cards)
// ==============================================

(function() {
	'use strict';

	var SELECTORS = {
		optionRadio: '.js-card-option-radio',
		variantHidden: '.js-card-variant-id',
		variantsJson: '.js-card-variants-json',
		addButton: '.js-quick-add-btn',
		productCard: '.product-card',
		cartCount: '.js-cart-item-count',
		optionLabel: '.card-option-label',
		optionGroup: '.card-option-group',
		price: '.js-card-price'
	};

	var CLASSES = {
		loading: 'is-loading',
		success: 'is-success',
		error: 'is-error',
		cartUpdated: 'cart-updated',
		unavailable: 'is-unavailable',
		selected: 'is-selected'
	};

	function getVariantsData($card) {
		var $json = $card.find(SELECTORS.variantsJson);
		if (!$json.length) return null;
		try {
			return JSON.parse($json.html());
		} catch (e) {
			return null;
		}
	}

	function getSelectedOptions($card) {
		var selected = [];
		$card.find(SELECTORS.optionRadio + ':checked').each(function() {
			var index = parseInt($(this).data('option-index'), 10);
			selected[index] = $(this).val();
		});
		return selected;
	}

	function getOptionCount($card) {
		return $card.find(SELECTORS.optionGroup).length;
	}

	function findMatchingVariant(variants, selectedOptions) {
		if (!variants) return null;

		for (var i = 0; i < variants.length; i++) {
			var variant = variants[i];
			var match = true;

			for (var j = 0; j < selectedOptions.length; j++) {
				if (selectedOptions[j] !== undefined && variant.options[j] !== selectedOptions[j]) {
					match = false;
					break;
				}
			}

			if (match) return variant;
		}
		return null;
	}

	// Check if an option value has any available variant
	function isOptionAvailable(variants, optionIndex, optionValue, selectedOptions) {
		return variants.some(function(variant) {
			// Must match this option value
			if (variant.options[optionIndex] !== optionValue) return false;
			// Must be available
			if (!variant.available) return false;
			// Must match all other selected options
			for (var i = 0; i < selectedOptions.length; i++) {
				if (i !== optionIndex && selectedOptions[i] !== undefined) {
					if (variant.options[i] !== selectedOptions[i]) return false;
				}
			}
			return true;
		});
	}

	function updateOptionAvailability($card, variants, selectedOptions) {
		$card.find(SELECTORS.optionGroup).each(function() {
			var groupIndex = parseInt($(this).data('option-index'), 10);

			$(this).find(SELECTORS.optionRadio).each(function() {
				var $radio = $(this);
				var $label = $radio.next(SELECTORS.optionLabel);
				var optionValue = $radio.val();

				var hasAvailable = isOptionAvailable(variants, groupIndex, optionValue, selectedOptions);

				if (hasAvailable) {
					$label.removeClass(CLASSES.unavailable);
				} else {
					$label.addClass(CLASSES.unavailable);
				}
			});
		});
	}

	function updateCardImage($card, variant, isSquare) {
		var $imageContainer = $card.find('.js-card-image');
		if (!$imageContainer.length) return;

		var $img = $imageContainer.find('img');
		if (!$img.length) return;

		if (variant && variant.featured_image) {
			var newSrc = isSquare ? variant.featured_image.src : variant.featured_image.src_rect;
			if (newSrc) {
				$img.attr('src', newSrc);
			}
		}
	}

	function updateCardState($card) {
		var $addButton = $card.find(SELECTORS.addButton);
		var optionCount = getOptionCount($card);
		var variants = getVariantsData($card);
		var selectedOptions = getSelectedOptions($card);

		// Update availability styling
		if (variants) {
			updateOptionAvailability($card, variants, selectedOptions);
		}

		// Count how many options are selected
		var selectedCount = selectedOptions.filter(function(opt) {
			return opt !== undefined;
		}).length;

		// Find the matching variant
		var matchedVariant = findMatchingVariant(variants, selectedOptions);

		// Update price display
		if (matchedVariant && matchedVariant.price) {
			$card.find(SELECTORS.price).text(matchedVariant.price);
		}

		// Update card image
		var $img = $card.find('.js-card-image img');
		if ($img.length) {
			var isSquare = $img.attr('src').indexOf('700x700') > -1;
			updateCardImage($card, matchedVariant, isSquare);
		}

		// Enable/disable add to cart button
		if (selectedCount === optionCount && matchedVariant && matchedVariant.available) {
			$addButton.prop('disabled', false);
			$card.data('selected-variant-id', matchedVariant.id);
		} else {
			$addButton.prop('disabled', true);
			$card.removeData('selected-variant-id');
		}
	}

	function onOptionChange(event) {
		var $radio = $(event.target);
		var $card = $radio.closest(SELECTORS.productCard);
		var $label = $radio.next(SELECTORS.optionLabel);

		// Update selected state visually within this option group
		$radio.closest(SELECTORS.optionGroup).find(SELECTORS.optionLabel).removeClass(CLASSES.selected);
		$label.addClass(CLASSES.selected);

		// Update the card state (availability, button, price, image)
		updateCardState($card);
	}

	function getSelectedVariantId($card) {
		var $hidden = $card.find(SELECTORS.variantHidden);
		if ($hidden.length) {
			return $hidden.val();
		}
		return $card.data('selected-variant-id') || null;
	}

	function updateCartCount(newCount) {
		var $cartCount = $(SELECTORS.cartCount);
		$cartCount.text('(' + newCount + ')');
		$cartCount.addClass(CLASSES.cartUpdated);
		setTimeout(function() {
			$cartCount.removeClass(CLASSES.cartUpdated);
		}, 400);
	}

	function setButtonState($button, state) {
		$button.removeClass(CLASSES.loading + ' ' + CLASSES.success + ' ' + CLASSES.error);
		if (state) {
			$button.addClass(state);
		}
	}

	function onAddToCart(event) {
		event.preventDefault();
		event.stopPropagation();

		var $button = $(event.target);
		var $card = $button.closest(SELECTORS.productCard);
		var variantId = getSelectedVariantId($card);

		if (!variantId) {
			return;
		}

		if ($button.hasClass(CLASSES.loading)) {
			return;
		}

		setButtonState($button, CLASSES.loading);
		$button.prop('disabled', true);

		$.ajax({
			url: '/cart/add.js',
			type: 'POST',
			dataType: 'json',
			data: {
				id: variantId,
				quantity: 1
			},
			success: function(response) {
				setButtonState($button, CLASSES.success);

				$.getJSON('/cart.js', function(cart) {
					updateCartCount(cart.item_count);

					// Open cart drawer
					if (window.cartDrawer) {
						window.cartDrawer.open();
					}
				});

				setTimeout(function() {
					setButtonState($button, null);
					// Re-enable button if a variant is still selected (allow adding same variant again)
					var currentVariantId = getSelectedVariantId($card);
					if (currentVariantId) {
						$button.prop('disabled', false);
					}
				}, 1500);
			},
			error: function(xhr, status, error) {
				setButtonState($button, CLASSES.error);

				setTimeout(function() {
					setButtonState($button, null);
					var variantSelected = getSelectedVariantId($card);
					$button.prop('disabled', !variantSelected);
				}, 2000);
			}
		});
	}

	// Initialize all product cards on page load
	function initializeCards() {
		$(SELECTORS.productCard).each(function() {
			var $card = $(this);
			var variants = getVariantsData($card);

			// Only initialize cards that have variants (not single-variant products)
			if (!variants) return;

			// Mark unavailable options on initial load (no options selected yet)
			// An option is unavailable if there's no available variant with that option value
			$card.find(SELECTORS.optionGroup).each(function() {
				var groupIndex = parseInt($(this).data('option-index'), 10);

				$(this).find(SELECTORS.optionRadio).each(function() {
					var $radio = $(this);
					var $label = $radio.next(SELECTORS.optionLabel);
					var optionValue = $radio.val();

					// Check if ANY variant with this option value is available
					var hasAvailable = variants.some(function(variant) {
						return variant.options[groupIndex] === optionValue && variant.available;
					});

					if (!hasAvailable) {
						$label.addClass(CLASSES.unavailable);
					}
				});
			});
		});
	}

	function init() {
		// Initialize cards first to show sold-out options
		initializeCards();

		// Bind event handlers
		$(document).on('change', SELECTORS.optionRadio, onOptionChange);
		$(document).on('click', SELECTORS.addButton, onAddToCart);
	}

	$(document).ready(init);

})();

// ==============================================
// Cart Drawer
// ==============================================

(function() {
	'use strict';

	var SELECTORS = {
		drawer: '#cart-drawer',
		drawerBody: '.js-cart-drawer-body',
		drawerFooter: '.js-cart-drawer-footer',
		drawerToggle: '.js-cart-drawer-toggle',
		drawerClose: '.js-cart-drawer-close',
		cartCount: '.js-cart-item-count',
		quantityButton: '.js-drawer-quantity-button',
		removeButton: '.js-drawer-remove-item'
	};

	var CLASSES = {
		open: 'is-open',
		loading: 'is-loading',
		empty: 'is-empty',
		updating: 'is-updating'
	};

	var cartDrawer = {
		isOpen: false,
		isUpdating: false,

		open: function() {
			$(SELECTORS.drawer).addClass(CLASSES.open);
			$('body').addClass('cart-drawer-open');
			this.isOpen = true;
			this.refresh();
		},

		close: function() {
			$(SELECTORS.drawer).removeClass(CLASSES.open);
			$('body').removeClass('cart-drawer-open');
			this.isOpen = false;
		},

		toggle: function() {
			if (this.isOpen) {
				this.close();
			} else {
				this.open();
			}
		},

		refresh: function() {
			var self = this;
			$(SELECTORS.drawerBody).addClass(CLASSES.loading);
			$(SELECTORS.drawerBody).html('');

			$.getJSON('/cart.js', function(cart) {
				self.render(cart);
				$(SELECTORS.drawerBody).removeClass(CLASSES.loading);
			});
		},

		render: function(cart) {
			var $body = $(SELECTORS.drawerBody);
			var $footer = $(SELECTORS.drawerFooter);

			if (cart.item_count === 0) {
				$body.html(this.renderEmpty());
				$footer.html('');
				$(SELECTORS.drawer).addClass(CLASSES.empty);
			} else {
				$body.html(this.renderItems(cart));
				$footer.html(this.renderFooter(cart));
				$(SELECTORS.drawer).removeClass(CLASSES.empty);
			}

			$(SELECTORS.cartCount).text('(' + cart.item_count + ')');
		},

		renderEmpty: function() {
			var strings = window.cartDrawerStrings || {};
			return '<div class="cart-drawer-empty">' +
				'<p class="cart-drawer-empty-title">' + (strings.emptyTitle || 'Your cart is empty') + '</p>' +
				'<a href="/" class="cart-drawer-continue">' + (strings.continueShopping || 'Continue Shopping') + '</a>' +
			'</div>';
		},

		renderItems: function(cart) {
			var html = '<div class="cart-drawer-items">';

			for (var i = 0; i < cart.items.length; i++) {
				html += this.renderItem(cart.items[i], i + 1);
			}

			html += '</div>';
			return html;
		},

		renderItem: function(item, lineIndex) {
			var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
				? '<span class="cart-drawer-item-variant">' + item.variant_title + '</span>'
				: '';

			return '<div class="cart-drawer-item" data-line="' + lineIndex + '" data-key="' + item.key + '">' +
				'<div class="cart-drawer-item-image">' +
					'<a href="' + item.url + '">' +
						'<img src="' + this.getSizedImageUrl(item.image, '150x') + '" alt="' + this.escapeHtml(item.title) + '">' +
					'</a>' +
				'</div>' +
				'<div class="cart-drawer-item-details">' +
					'<a href="' + item.url + '" class="cart-drawer-item-title">' + this.escapeHtml(item.product_title) + '</a>' +
					variantTitle +
					'<span class="cart-drawer-item-price">' + this.formatMoney(item.price) + '</span>' +
					'<div class="cart-drawer-item-quantity">' +
						'<div class="quantity-picker">' +
							'<button class="quantity-button minus js-drawer-quantity-button" type="button" data-action="decrease">&ndash;</button>' +
							'<span class="quantity-text">' + item.quantity + '</span>' +
							'<button class="quantity-button plus js-drawer-quantity-button" type="button" data-action="increase">+</button>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<button class="cart-drawer-item-remove js-drawer-remove-item" type="button" aria-label="Remove item">' +
					'<svg viewBox="0 0 100 100"><polygon points="100,14.1381836 85.8618164,0 50,35.8618164 14.1381836,0 0,14.1381836 35.8618164,50 0,85.8618164 14.1381836,100 50,64.1381836 85.8618164,100 100,85.8618164 64.1381836,50"/></svg>' +
				'</button>' +
			'</div>';
		},

		renderFooter: function(cart) {
			var strings = window.cartDrawerStrings || {};
			return '<div class="cart-drawer-subtotal">' +
				'<span class="cart-drawer-subtotal-label">' + (strings.subtotal || 'Subtotal') + ':</span>' +
				'<span class="cart-drawer-subtotal-price">' + this.formatMoney(cart.total_price) + '</span>' +
			'</div>' +
			'<p class="cart-drawer-shipping">' + (strings.shipping || 'Shipping calculated at checkout') + '</p>' +
			'<a href="/checkout" class="cart-drawer-checkout button">' + (strings.checkout || 'Checkout') + '</a>' +
			'<a href="/cart" class="cart-drawer-view-cart">' + (strings.viewCart || 'View Cart') + '</a>';
		},

		updateQuantity: function(line, quantity, $item) {
			if (this.isUpdating) return;

			var self = this;
			this.isUpdating = true;
			$item.addClass(CLASSES.updating);

			$.ajax({
				url: '/cart/change.js',
				type: 'POST',
				dataType: 'json',
				data: {
					line: line,
					quantity: quantity
				},
				success: function(cart) {
					self.render(cart);
					self.isUpdating = false;
				},
				error: function() {
					self.refresh();
					self.isUpdating = false;
				}
			});
		},

		removeItem: function(line, $item) {
			this.updateQuantity(line, 0, $item);
		},

		formatMoney: function(cents) {
			return '$' + (cents / 100).toFixed(2);
		},

		getSizedImageUrl: function(src, size) {
			if (!src) return '';
			return src.replace(/\.([^.]*)$/, '_' + size + '.$1');
		},

		escapeHtml: function(text) {
			var div = document.createElement('div');
			div.textContent = text;
			return div.innerHTML;
		},

		onToggleClick: function(event) {
			event.preventDefault();
			this.toggle();
		},

		onCloseClick: function(event) {
			event.preventDefault();
			this.close();
		},

		onQuantityButtonClick: function(event) {
			var $button = $(event.target).closest(SELECTORS.quantityButton);
			var $item = $button.closest('.cart-drawer-item');
			var currentQty = parseInt($item.find('.quantity-text').text(), 10);
			var newQty = $button.data('action') === 'increase' ? currentQty + 1 : currentQty - 1;
			var line = parseInt($item.data('line'), 10);

			if (newQty < 0) newQty = 0;

			this.updateQuantity(line, newQty, $item);
		},

		onRemoveClick: function(event) {
			var $button = $(event.target).closest(SELECTORS.removeButton);
			var $item = $button.closest('.cart-drawer-item');
			var line = parseInt($item.data('line'), 10);

			this.removeItem(line, $item);
		},

		onEscapeKey: function(event) {
			if (event.key === 'Escape' && this.isOpen) {
				this.close();
			}
		},

		init: function() {
			var self = this;

			$(document).on('click', SELECTORS.drawerToggle, function(e) {
				self.onToggleClick(e);
			});

			$(document).on('click', SELECTORS.drawerClose, function(e) {
				self.onCloseClick(e);
			});

			$(document).on('click', SELECTORS.quantityButton, function(e) {
				self.onQuantityButtonClick(e);
			});

			$(document).on('click', SELECTORS.removeButton, function(e) {
				self.onRemoveClick(e);
			});

			$(document).on('keydown', function(e) {
				self.onEscapeKey(e);
			});
		}
	};

	window.cartDrawer = cartDrawer;

	$(document).ready(function() {
		cartDrawer.init();
	});

})();


